import Grid from "@mui/material/Unstable_Grid2/Grid2";
import Service from "./Service";
import { useTranslation } from "react-i18next";
// import PaymentIcon from '@mui/icons-material/Payment';
import CarSearchIcon from "../../assets/CarSearchIcon";
import CalendarRangeIcon from "../../assets/CalendarRangeIcon";
// import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import DomainIcon from '@mui/icons-material/Domain';
// import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
// import TimerCheckedIcon from "../../assets/TimerCheckedIcon";
// import AccountGroupIcon from "../../assets/AccountGroupIcon";
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import { CircularProgress } from "@mui/material";

export default function ServiceList() {
    const { t } = useTranslation();
    return (
        <Grid className="max-w-[504px]" container rowSpacing={{ xs: 2, sm: 5, md: 3 }} columnSpacing={{ xs: 1, sm: 5, md: 3 }}>
            <Grid xs={6}><Service title={t('search_with_chassis')} icon={<CarSearchIcon className="w-16 h-16" />} to="/search/chassis" /></Grid>
            <Grid xs={6}><Service title={t('search_with_date')} icon={<CalendarRangeIcon className="w-16 h-16" />} to="/search/date" /></Grid>
            <Grid xs={6}><Service title={t('search_with_license_plate')} icon={<ConfirmationNumberIcon className="w-16 h-16" />} to="/search/license-plate" /></Grid>            
            <Grid xs={6}><Service title={t('financial_reports')} icon={<CircularProgress className="w-16 h-16" variant="determinate" color="inherit" value={75} />} to="/report" /></Grid>
            <Grid xs={6}><Service title={t('customers')} icon={<CircularProgress className="w-16 h-16" variant="determinate" color="inherit" value={75} />} to="/" /></Grid>
            <Grid xs={6}><Service title={t('employee')} icon={<CircularProgress className="w-16 h-16" variant="determinate" color="inherit" value={75} />} to="/" /></Grid>
            <Grid xs={6}><Service title={t('branches')} icon={<DomainIcon className="w-16 h-16" />} to="/branch" /></Grid>
            <Grid xs={6}><Service title={t('notifications_soon')} icon={<CircularProgress className="w-16 h-16" variant="determinate" color="inherit" value={75} />} to="/" /></Grid>
        </Grid>
    )
}
